import { IEntity, IProduct, IProductMetadata } from '@/models';
import { stringContainsAllWords } from '@/utilities';

export const findProduct = (products: IProduct[], id: number) => {
  if (!products || products.length < 1 || !id || id === 0) return undefined;
  return products.find((product) => product.id === id);
};

export const findProductByBarCode = (products: IProduct[], barCode: string) => {
  if (!products || products.length < 1 || !barCode || barCode === "") return undefined;
  return products.find((product) => product.code === barCode);
};

export const filterProductsByName = (products: IProduct[], name: string) =>
  filterProductsByField(products, name, (product) => product.name);

export const filterProductsByLab = (products: IProduct[], lab: string) =>
  filterProductsByField(products, lab, (product) => product.metadata.laboratory ?? "");

export const filterProductsByActiveIngredient = (products: IProduct[], activeIngredient: string) =>
  filterProductsByField(products, activeIngredient, (product) => product.metadata.activeIngredient ?? "");

export const filterProductsByPathology = (products: IProduct[], pathology: string) =>
  filterProductsByField(products, pathology, (product) => product.metadata.pathology ?? "");

export const filterProductsByBarCode = (products: IProduct[], barCode: string) =>
  filterProductsByField(products, barCode, (product) => product.code ?? "");

const filterProductsByField = (
  products: IProduct[],
  value: string,
  fieldGetter: (product: IProduct) => string
): IProduct[] => {
  if (!value || value === "") return [];

  return products.filter((product) => stringContainsAllWords(fieldGetter(product), value));
};

export function getUniqueAttributeWithIds<T extends keyof IProductMetadata>(
  products: IProduct[] | undefined,
  attribute: T
): { id: number; name: string }[] {

  if (!products || products.length < 1) {
    return [];
  }

  const uniqueValues = Array.from(
    new Set(
      products
        .map((product) => product.metadata[attribute])
        .filter((value): value is string => value !== null)
    )
  );

  return uniqueValues.map((value, index) => ({
    id: index + 1,
    name: value,
  }));
}

export const filterEntities = (
  entities: IEntity[],
  value: string,
): IEntity[] => {
  if (!value || value === "") return [];

  return entities.filter(({ name }) => stringContainsAllWords(name, value));
};